export const STATISTICS_PORTAL = 'statisticsPortal';

export const STATISTICS_PORTAL_ACTIONS_NAME = {
  getVisitsCountByTimeTable: `${STATISTICS_PORTAL}/getVisitsCountByTimeTable`,
  getVisitsCountByGroupsTable: `${STATISTICS_PORTAL}/getVisitsCountByGroupsTable`,
  getVisitsCountByUsersTable: `${STATISTICS_PORTAL}/getVisitsCountByUsersTable`,
  getAverageVisitsTimeTable: `${STATISTICS_PORTAL}/getAverageVisitsTimeTable`,
  getViewsCountByTimeTable: `${STATISTICS_PORTAL}/getViewsCountByTimeTable`,
  getPagesTable: `${STATISTICS_PORTAL}/getPagesTable`,
  getSectionsTable: `${STATISTICS_PORTAL}/getSectionsTable`,
  getUniqueVisitsCountTable: `${STATISTICS_PORTAL}/getUniqueVisitsCountTable`,
  getViewsCountByTimeChartData: `${STATISTICS_PORTAL}/getViewsCountByTimeChartData`,
  getUniqueVisitsCountChartData: `${STATISTICS_PORTAL}/getUniqueVisitsCountChartData`,
  getAverageVisitsTimeChartData: `${STATISTICS_PORTAL}/getAverageVisitsTimeChartData`,
  getVisitsCountByTimeChartData: `${STATISTICS_PORTAL}/getVisitsCountByTimeChartData`,
};

export const STATISTICS_PORTAL_MUTATIONS_NAME = {
  setVisitsCountByTimeTable: `${STATISTICS_PORTAL}/setVisitsCountByTimeTable`,
  setVisitsCountByGroupsTable: `${STATISTICS_PORTAL}/setVisitsCountByGroupsTable`,
  setVisitsCountByUsersTable: `${STATISTICS_PORTAL}/setVisitsCountByUsersTable`,
  setAverageVisitsTimeTable: `${STATISTICS_PORTAL}/setAverageVisitsTimeTable`,
  setViewsCountByTimeTable: `${STATISTICS_PORTAL}/setViewsCountByTimeTable`,
  setPagesTable: `${STATISTICS_PORTAL}/setPagesTable`,
  setSectionsTable: `${STATISTICS_PORTAL}/setSectionsTable`,
  setUniqueVisitsCountTable: `${STATISTICS_PORTAL}/setUniqueVisitsCountTable`,
  setViewsCountByTimeChartData: `${STATISTICS_PORTAL}/setViewsCountByTimeChartData`,
  setUniqueVisitsCountChartData: `${STATISTICS_PORTAL}/setUniqueVisitsCountChartData`,
  setAverageVisitsTimeChartData: `${STATISTICS_PORTAL}/setAverageVisitsTimeChartData`,
  setVisitsCountByTimeChartData: `${STATISTICS_PORTAL}/setVisitsCountByTimeChartData`,
};

export const STATISTICS_PORTAL_GETTERS_NAME = {
  getVisitsCountByTimeTable: `${STATISTICS_PORTAL}/getVisitsCountByTimeTable`,
  getVisitsCountByGroupsTable: `${STATISTICS_PORTAL}/getVisitsCountByGroupsTable`,
  getVisitsCountByUsersTable: `${STATISTICS_PORTAL}/getVisitsCountByUsersTable`,
  getAverageVisitsTimeTable: `${STATISTICS_PORTAL}/getAverageVisitsTimeTable`,
  getViewsCountByTimeTable: `${STATISTICS_PORTAL}/getViewsCountByTimeTable`,
  getPagesTable: `${STATISTICS_PORTAL}/getPagesTable`,
  getSectionsTable: `${STATISTICS_PORTAL}/getSectionsTable`,
  getUniqueVisitsCountTable: `${STATISTICS_PORTAL}/getUniqueVisitsCountTable`,
  getViewsCountByTimeChartData: `${STATISTICS_PORTAL}/getViewsCountByTimeChartData`,
  getUniqueVisitsCountChartData: `${STATISTICS_PORTAL}/getUniqueVisitsCountChartData`,
  getAverageVisitsTimeChartData: `${STATISTICS_PORTAL}/getAverageVisitsTimeChartData`,
  getVisitsCountByTimeChartData: `${STATISTICS_PORTAL}/getVisitsCountByTimeChartData`,
};
